export const categoriesUY = [
    {
        id: 'Corn',
        icon: 'corn',
        category: 'Maíz',
        color: 'orange',
        subcategories: [
            { id: 'Hybrids', subcategory: 'Híbridos', icon: 'corn', color: 'orange' },
            { id: 'Agronomic Practices', subcategory: 'Prácticas agronómicas', icon: 'corn', color: 'orange' },
            { id: 'Weeds', subcategory: 'Malezas', icon: 'weeds', color: 'orange' },
            { id: 'Diseases', subcategory: 'Enfermadades', icon: 'diseases', color: 'orange' },
            { id: 'Pests', subcategory: 'Plagas', icon: 'pests', color: 'orange' },
            { id: 'Other', subcategory: 'Otros', icon: 'others', color: 'orange' },
        ],
    },
    {
        id: 'Soy',
        icon: 'soy',
        category: 'Soja',
        color: 'green',
        subcategories: [
            { id: 'Hybrids', subcategory: 'Variedades', icon: 'soy', color: 'green' },
            { id: 'Agronomic Practices', subcategory: 'Prácticas agronómicas', icon: 'soy', color: 'green' },
            { id: 'Weeds', subcategory: 'Malezas', icon: 'weeds', color: 'green' },
            { id: 'Diseases', subcategory: 'Enfermadades', icon: 'diseases', color: 'green' },
            { id: 'Pests', subcategory: 'Plagas', icon: 'pests', color: 'green' },
            { id: 'Other', subcategory: 'Otros', icon: 'others', color: 'green' },
        ],
    },
    {
        id: 'Cereals',
        icon: 'cereal',
        category: 'Cereales',
        color: 'brown',
        subcategories: [
            { id: 'Weeds', subcategory: 'Malezas', icon: 'weeds', color: 'brown' },
            { id: 'Diseases', subcategory: 'Enfermadades', icon: 'diseases', color: 'brown' },
            { id: 'Pests', subcategory: 'Plagas', icon: 'pests', color: 'brown' },
            { id: 'Other', subcategory: 'Otros', icon: 'others', color: 'brown' },
        ],
    },
    {
        id: 'App',
        icon: 'consultApps',
        category: 'App',
        color: 'blue',
        subcategories: [
            { id: 'Problem', subcategory: 'Tengo un problema', icon: 'problem', color: 'blue' },
            { id: 'How to', subcategory: 'Cómo funciona', icon: 'howItWorks', color: 'blue' },
            { id: 'Other', subcategory: 'Otros', icon: 'others', color: 'blue' },
        ],
    },
    { id: 'Other', icon: 'others', category: 'Otros', color: 'green-light', subcategories: [] },
];
